import React from 'react';
import {
    Dialog,
    DialogActions,
    Box,
    Typography,
    Button,
    Paper,
    alpha,
    useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {
    getDialogPaperStyle,
    getHeaderBoxStyle,
    getHeaderTitleStyle,
    getHeaderSubtitleStyle,
    getContentContainerStyle,
    getPaperStyle,
    getSectionBoxStyle,
    getBottomSectionBoxStyle,
    getTypographyStyle,
    getDialogActionsStyle,
    getActionButtonsContainerStyle,
    getCancelButtonStyle,
    getProceedButtonStyle
} from './PaymentGuidelinesModalCss';

/**
 * Reusable Payment Guidelines Modal.
 * Shows payment guidelines before proceeding with add funds.
 *
 * @param {boolean} open - Whether the modal is open
 * @param {function} onClose - Called when the modal should close
 * @param {function} onProceed - Called when the user clicks "Proceed"
 */
const PaymentGuidelinesModal = ({ open, onClose, onProceed }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            PaperProps={{
                sx: getDialogPaperStyle(isMobile)
            }}
        >
            {/* Custom Modal Header */}
            <Box sx={getHeaderBoxStyle}>
                <Box>
                    <Box sx={getHeaderTitleStyle()}>Payment Guidelines</Box>
                    <Box sx={getHeaderSubtitleStyle()}>Please read carefully before proceeding</Box>
                </Box>
            </Box>
            {/* Scrollable content */}
            <Box sx={getContentContainerStyle()}>
                <Paper
                    elevation={0}
                    sx={getPaperStyle(theme)}
                >
                    <Box sx={getSectionBoxStyle(theme)}>
                        <Typography variant="body2" color="text.secondary" sx={getTypographyStyle()}>
                            You must use the same bank account for both deposit and withdrawal.
                            If a mismatch is found, your trading account may be blocked without prior notice.
                        </Typography>
                    </Box>
                    <Box sx={getBottomSectionBoxStyle(theme)}>
                        <Typography variant="body2" color="text.secondary" sx={getTypographyStyle()}>
                            Transaction screenshot is mandatory for all deposits.
                            The screenshot must clearly show the UTR number and transaction details.
                        </Typography>
                    </Box>
                </Paper>
            </Box>
            <DialogActions sx={getDialogActionsStyle(theme, isMobile)}>
                <Box sx={getActionButtonsContainerStyle(isMobile)}>
                    <Button
                        size={isMobile ? "large" : "small"}
                        onClick={onClose}
                        fullWidth={isMobile}
                        variant={isMobile ? "outlined" : "text"}
                        sx={getCancelButtonStyle(theme, isMobile)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={onProceed}
                        size={isMobile ? "large" : "small"}
                        endIcon={<ArrowForwardIcon />}
                        fullWidth={isMobile}
                        sx={getProceedButtonStyle(theme, isMobile)}
                    >
                        Proceed
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default PaymentGuidelinesModal;
